import React from 'react';
import { useTranslate } from '@translations/useTranslate';
import TermsOfUseStyles from './TermsOfUseStyles.module.scss';

const TermsOfUse = () => {
  const { t } = useTranslate();

  return (
    <>
      <h5 className={TermsOfUseStyles.title}>{t('terms.of.use.title')}</h5>
      <div className={TermsOfUseStyles.termsOfUseBox}>
        <div dir="ltr">
          <p>
            Please read the following Terms of Use that govern the usage of TAWAL’s Systems
            carefully before accessing or using the System. By accessing or using the System, you
            agree to comply and adhere to these Terms of Use and any other policies or guidelines
            implemented by TAWAL. If you do not agree with the Terms of Use, please do not use the
            System. If you accept to be bound by such Terms of Use, please click &quot;agree&quot;
            or “accept”. Please note that by clicking &quot;agree&quot;, “accept” or using any of
            the Systems, you confirm your acceptance of these Terms of Use and to be fully bound to
            it.
          </p>
          <br />
          <ol>
            <li>
              &nbsp;&nbsp;
              <strong>Definitions:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>“Account”</strong> refers to a User account created by a User for
                  accessing or using certain features or services on the System.
                </li>
                <br />
                <li>
                  <strong>“Content”</strong> refers to (i) any text, images, videos, audio, logs,
                  metadata, and any other materials posted or published by TAWAL at the System, and
                  (ii) any data, information, and/or documents uploaded or submitted by a User on
                  the System.
                </li>
                <br />
                <li>
                  <strong>“Data”</strong> refers to any information, including Personal Data and
                  Content, that is collected, stored, or processed by TAWAL through the System.
                </li>
                <br />
                <li>
                  <strong>“Feedback”</strong> refers to the meaning stated under sub-clause 19.1
                  hereto.
                </li>
                <br />
                <li>
                  <strong>&quot;Intellectual Property&quot;</strong> refers to all copyrights,
                  trademarks, patents, trade secrets, and other intellectual property rights,
                  whether registered or unregistered.
                </li>
                <br />
                <li>
                  <strong>“Personal Data”</strong> refers to any personal information relating to an
                  identified or identifiable natural person, including User personal information
                  (i.e., names, contact information, usage data, etc.) as further defined by the
                  applicable Saudi Personal Data Protection Law (PDPL).
                </li>
                <br />
                <li>
                  <strong>“System”</strong> refers to any of TAWAL’s websites, platforms, software,
                  applications, and systems that can be accessed or used by the User.
                </li>
                <br />
                <li>
                  <strong>“TAWAL”</strong> refers to{' '}
                  <strong>Telecommunications Towers Company J.S.C.</strong>, a Saudi company
                  incorporated pursuant to the laws of the Kingdom of Saudi Arabia and registered
                  under commercial registration No. (1010933182), having its address at TAWAL Tower,
                  Building No. 3210, Al-Thumamah Road, Al-Sahafah District, Riyadh 13315 – 6228, the
                  Kingdom of Saudi Arabia, the owner and operator of the System.
                </li>
                <br />
                <li>
                  <strong>“TAWAL Contact Details”</strong> refers to the meaning stated under
                  sub-clause 20.1 hereto.
                </li>
                <br />
                <li>
                  <strong>“Terms of Use”</strong> refers to the terms and conditions stated herein
                  that govern the use and access of a User to the System, including any
                  modifications, amendments, or updates made by TAWAL to such Terms of Use from time
                  to time.
                </li>
                <br />
                <li>
                  <strong>“User”</strong> refers to any individual or entity that interacts with or
                  accesses the System, including developers, end-users, and other authorized
                  parties.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>USER RIGHTS AND RESPONSIBILITIES:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>User Rights:</strong>
                  <ol>
                    <li>
                      <strong>Access and Use:</strong> Users have the right to access and use the
                      System in accordance with the Terms of Use subject always to the applicable
                      laws and regulations.
                    </li>
                    <br />
                    <li>
                      <strong>Privacy:</strong> Users have the right to privacy and data protection
                      as outlined in clause 4 hereto (Privacy Policy). TAWAL is committed to
                      protecting the Personal Data that Users share.
                    </li>
                    <br />
                    <li>
                      <strong>Support:</strong> Users have the right to contact TAWAL’s support team
                      for assistance with accessing or using the System and resolving any issues
                      they encounter. Support requests will be handled in accordance with
                      TAWAL&#39;s established processes.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <strong>User Responsibilities:</strong>
                  <ol>
                    <li>
                      <strong>Compliance:</strong> Users must comply with all applicable laws and
                      regulations when using the System. This includes, but is not limited to, laws
                      related to intellectual property, data protection, and privacy.
                    </li>
                    <br />
                    <li>
                      <strong>Account Security:</strong> Users are responsible for maintaining the
                      confidentiality of their Account’s credentials and for all activities that
                      occur under their Accounts. Users must notify TAWAL immediately of any
                      unauthorized use of their Accounts.
                    </li>
                    <br />
                    <li>
                      <strong>Prohibited Conduct:</strong> Users must not engage in any activity
                      that:
                      <ol>
                        <li>
                          violates the rights of others, including intellectual property rights and
                          privacy rights,
                        </li>
                        <li>is illegal, fraudulent, or harmful,</li>
                        <li>
                          involves the transmission of malware, viruses, or other harmful code, and
                        </li>
                        <li>interferes with or disrupts the System or its services.</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <strong>Content Standards:</strong> Users must ensure that any content they
                      post, publish, or submit to TAWAL through the System:
                      <ol>
                        <li>is accurate and not misleading,</li>
                        <li>does not infringe the rights of any third party, and</li>
                        <li>is not defamatory, obscene, offensive, or otherwise inappropriate.</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <strong>IBS request conditions:</strong>
                      <ol>
                        <li>
                          To enable TAWAL to use and utilize the Premises for carrying out IBS
                          Works.
                        </li>
                        <li>
                          All IBS Equipment is the sole ownership of TAWAL and/or the respective
                          MNOS, and Landlord does not have any right, whatsoever, of access,
                          seizure, attachment, and/or operation on the Equipment.
                        </li>
                        <li>
                          All IBS Equipment are kept at the Premises and shall maintain and keep it
                          safe in a good and workmanlike manner and shall not cause damage to any of
                          the Equipment and shall not misuse, relocate, dismantle, and/or block the
                          usage of or dispose of the Equipment in any manner without the prior
                          written consent and actual presence of TAWAL and its SPOC in this regard.
                        </li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      <strong>Reporting Violations:</strong> Users are required to report to TAWAL
                      any violations of or other inappropriate behaviours in relation to these Terms
                      of Use
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>CONFIDENTIALITY:</strong> <br /> <br />
              <ol>
                <li>
                  <strong>Confidential Information:</strong>
                  <ol>
                    <li>
                      Users acknowledge that all information, including all third-party information,
                      provided or disclosed to them from or through the System during their access
                      or use of the System (the <strong>“Confidential Information”</strong>) shall
                      be treated as confidential and shall not be disclosed, shared, or misused in
                      any way.
                    </li>
                    <br />
                    <li>
                      Users shall not disclose any Confidential Information to third parties without
                      the express prior written consent of TAWAL. Users must ensure that any third
                      parties who receive Confidential Information are bound by confidentiality
                      obligations at least as stringent as those in these Terms of Use.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <strong>Obligations:</strong> Users shall maintain the confidentiality of any
                  Confidential Information accessed or obtained through the System and use such
                  Confidential Information solely for the purpose for which it was provided. Users
                  shall take all reasonable measures to protect the confidentiality of all
                  Confidential Information.
                </li>
                <br />
                <li>
                  <strong>Exceptions:</strong> Users understand that the obligations of
                  confidentiality do not apply to information that is publicly available or becomes
                  known to the public through no fault of the Users. Users also understand that they
                  are not obligated to keep confidential any information that they can demonstrate
                  was already known to them prior to accessing or using the System.
                </li>
                <br />
                <li>
                  <strong>User Responsibility:</strong>
                  <ol>
                    <li>
                      Users are solely responsible for any unauthorized disclosure or use of
                      Confidential Information obtained through the System, and they shall indemnify
                      and hold harmless TAWAL from any losses, damages, or liabilities arising from
                      such unauthorized disclosure or use.
                    </li>
                    <br />
                    <li>
                      Users must comply with all applicable data protection and privacy laws when
                      handling Confidential Information.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <strong>Duration:</strong> The obligations of confidentiality outlined in this
                  clause shall survive the termination or expiration of the User&#39;s access to the
                  System and shall remain in effect indefinitely.
                </li>
                <br />
                <li>
                  <strong>Enforcement and Remedies:</strong>
                  <ol>
                    <li>
                      TAWAL reserves the right to terminate the User&#39;s access to the System
                      immediately upon discovering any breach of confidentiality. In such cases,
                      TAWAL is entitled to:
                      <ol>
                        <li>
                          Pursue legal action against Users who breach confidentiality to recover
                          any losses or damages incurred as a result of such breach, and
                        </li>
                        <li>
                          Seek injunctive relief and/or take any lawful preventive measures to
                          prevent any further unauthorized disclosure or use of Confidential
                          Information.
                        </li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      Users must immediately notify TAWAL of any suspected or actual breach of
                      confidentiality and cooperate fully with any investigation.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>PRIVACY POLICY:</strong> <br /> <br />
              <ol>
                <li>
                  <strong>Personal Data Collection:</strong> Users acknowledge that TAWAL is
                  entitled to collect and process Personal Data from them both during the
                  registration process and while they use or access the System.
                </li>
                <br />
                <li>
                  <strong>Use of Personal Data:</strong> TAWAL uses the collected Personal Data to
                  provide and improve its services, communicate with Users, and comply with legal
                  obligations.
                </li>
                <br />
                <li>
                  <strong>Personal Data Protection:</strong> TAWAL implements appropriate technical
                  and organizational measures to protect User&#39;s Personal Data against
                  unauthorized access, loss, alteration, or destruction.
                </li>
                <br />
                <li>
                  <strong>User Rights:</strong> Users have the right to access, rectify, delete, and
                  restrict the processing of their Personal Data as outlined in the applicable laws
                  and regulations. Users can exercise these rights by contacting TAWAL directly via
                  TAWAL Contact Details.
                </li>
                <br />
                <li>
                  <strong>Data Sharing with Third Parties:</strong> TAWAL may share the collected
                  Personal Data with third-party service providers essential to the operation of all
                  TAWAL’s services. All data sharing will be governed by applicable laws and
                  regulations and robust confidentiality agreements to safeguard personal
                  information.
                </li>
                <br />
                <li>
                  <strong>Data Retention and Destruction:</strong> TAWAL retains Personal Data only
                  for as long as necessary to fulfil the purposes for which it was collected, comply
                  with legal obligations, resolve disputes, and enforce agreements subject always to
                  the applicable laws and regulations. The destruction of Personal Data collected by
                  TAWAL will be conducted in accordance with applicable laws and regulations.
                </li>
                <br />
                <li>
                  <strong>Prohibition on Unauthorized Use of Content:</strong>
                  <ol>
                    <li>
                      Users shall not
                      <ol>
                        <li>
                          Copy or paste any Content from the System for any purpose not expressly
                          permitted by these Terms of Use,
                        </li>
                        <li>
                          Redistribute any Content from the System to third parties or any external
                          platforms without the express prior written consent of TAWAL, and
                        </li>
                        <li>
                          Reuse any Content from the System for any commercial or non-commercial
                          purposes outside the scope of these Terms of Use without explicit written
                          authorization from TAWAL.
                        </li>
                      </ol>
                      <li>
                        All use of Content from the System must be in strict compliance with these
                        Terms of Use and applicable laws and regulations. Any unauthorized use,
                        including copying, pasting, redistributing, or re-using Content, is strictly
                        prohibited and may result in termination of access and legal action(s)
                      </li>
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <strong>Data Breach Notification:</strong> In the event of a Data breach that
                  affects the Personal Data of Users, TAWAL will notify the affected Users and
                  relevant authorities in accordance with applicable laws and regulations.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>CHILDREN&#39;S PRIVACY:</strong>
              <br />
              <br />
              TAWAL does not knowingly collect personal data from children under the age of 13
              without verifiable parental consent in writing. If TAWAL becomes aware that a child
              under 13 has provided personal data without such consent, TAWAL will delete such
              information from the System.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>INTELLECTUAL PROPERTY:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>Content Ownership:</strong>
                  <br />
                  All Contents on the System are the property of TAWAL or its content suppliers and
                  are protected by copyright, trademark, patent, trade secret, and other
                  intellectual property or proprietary rights laws.
                </li>
                <br />
                <li>
                  <strong>Trademarks:</strong>
                  <br />
                  All trademarks, service marks, logos, and trade names displayed on the System are
                  the property of TAWAL or their respective owners. Users may not use any trademark,
                  service mark, logo, or trade name of TAWAL or any third party without obtaining
                  prior written permission from the respective owner.
                </li>
                <br />
                <li>
                  <strong>License and Access:</strong>
                  <br />
                  TAWAL grants Users a limited, non-exclusive, non-transferable, and revocable
                  license to access and use the System for personal, non-commercial use only. This
                  license does not include any resale or commercial use of the System or its
                  Contents; any collection and use of any product listings, descriptions, or prices;
                  any derivative use of the System or its Contents; any downloading or copying of
                  Account information for the benefit of another merchant; or any use of data
                  mining, robots, or similar data gathering and extraction tools.
                </li>
                <br />
                <li>
                  <strong>Restrictions:</strong>
                  <br />
                  Users may not frame or utilize framing techniques to enclose any trademark, logo,
                  or other proprietary information (including images, text, page layout, or form) of
                  TAWAL without express written consent. Framing techniques include but are not
                  limited to, displaying TAWAL’s content within a frame or border on another
                  website, making it appear as though the content belongs to the framing site. Users
                  may not use any meta tags or any other &quot;hidden text&quot; utilizing
                  TAWAL&#39;s name or trademarks without the express prior written consent of TAWAL.
                </li>
                <br />
                <li>
                  <strong>Reporting Infringements:</strong>
                  <br />
                  If Users believe that any Content on the System infringes their intellectual
                  property rights, they are encouraged to report it to TAWAL. TAWAL will investigate
                  and take appropriate action as necessary
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>USER-GENERATED DATA:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>Acceptable Use: </strong> Users are responsible for ensuring that any Data
                  they post or submit to the System is appropriate, and legal, and does not violate
                  any rights of others. This includes avoiding defamatory, offensive, or misleading
                  content.
                </li>
                <br />
                <li>
                  <strong>Monitoring and Removal:</strong> TAWAL reserves the right to monitor,
                  review, and remove any User-generated Data that violates these Terms of Use or is
                  otherwise inappropriate.
                </li>
                <br />
                <li>
                  <strong>Ownership of Data:</strong> By submitting Data to the System, Users grant
                  TAWAL a non-exclusive, royalty-free, worldwide license to use and process such
                  Data in connection with the System.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>THIRD-PARTY LINKS AND SERVICES:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>Disclaimer: </strong> The System may contain links to third-party websites
                  or services that are not owned or controlled by TAWAL. TAWAL has no control over,
                  and assumes no responsibility for, the content, privacy policies, or practices of
                  any third-party websites or services. Users shall, and have full responsibility
                  to, review third-party policies’ content, privacy policies, or practices before
                  using their services.
                </li>
                <br />
                <li>
                  <strong>User Responsibility:</strong> Users acknowledge and agree that TAWAL shall
                  not be responsible or liable, directly or indirectly, for any damage or loss
                  caused or alleged to be caused by or in connection with the use of or reliance on
                  any such content, goods, or services available on or through any such websites or
                  services.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>COOKIES AND TRACKING TECHNOLOGIES:</strong>
              <br />
              <br />
              TAWAL uses cookies and similar tracking technologies to track the activity on the
              System and hold certain information. Users can instruct their browser to refuse all
              cookies or to indicate when a cookie is being sent. However, if Users do not accept
              cookies, they may not be able to use some portions of the System.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>DISCLAIMERS AND LIMITATIONS OF LIABILITY:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>No Warranties:</strong>
                  <br />
                  TAWAL provides the System and its services &quot;as is&quot; and &quot;as
                  available,&quot; without any warranties of any kind, whether express or implied.
                  TAWAL does not guarantee that the System will be error-free, uninterrupted, or
                  secure.
                </li>
                <br />
                <li>
                  <strong>Limitation of Liability:</strong>
                  <br />
                  To the maximum extent permitted by applicable law, TAWAL shall not be liable for
                  any indirect, incidental, special, consequential, or punitive damages, or any loss
                  of profits or revenues, whether incurred directly or indirectly, or any loss of
                  data, use, goodwill, or other intangible losses resulting from (i) the use or
                  inability to access or use the System; (ii) any conduct or content of any third
                  party on the System; (iii) any Content obtained from the System; and (iv)
                  unauthorized access, use, or alteration of User&#39;s transmissions or Content.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>CINDEMNIFICATION:</strong>
              <br />
              Users shall indemnify and hold TAWAL harmless from any claims, damages, liabilities,
              costs, and expenses arising from their use of the System or any violation of these
              Terms of Use.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>FORCE MAJEURE:</strong>
              <br />
              TAWAL shall not be liable for any failure to perform or delay in performing its
              obligations under these Terms of Use if such failure or delay is due to causes beyond
              its reasonable control, including but not limited to acts of God, natural dis
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>CHANGES OF TERMS:</strong>
              <br />
              TAWAL reserves the right to amend these Terms of Use at any time. Users will be
              notified of any significant changes and continued use of the System by Users after
              such changes constitutes their acceptance of the amended or updated Terms of Use.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>DISPUTE RESOLUTION:</strong>
              <br />
              In the event of any dispute arising out of or relating to these Terms of Use or the
              use of the System, the parties agree to first attempt to negotiate in good faith to
              resolve the dispute. If the dispute cannot be resolved through negotiation, the
              parties agree to attempt to resolve the dispute through mediation before resorting to
              litigation.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>GOVERNING LAW AND JURISDICTION: </strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>Governing Law:</strong> These Terms of Use shall be governed by and
                  construed in accordance with the laws of the Kingdom of Saudi Arabia.
                </li>
                <br />
                <li>
                  <strong>Judicial Jurisdiction:</strong> Any disputes, that have not been resolved
                  amicably through mediation, arising out of or relating to these Terms of Use or
                  the use of the System shall be subject to the exclusive judicial jurisdiction of
                  the Riyadh competent courts, the Kingdom of Saudi Arabia.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>MODIFICATIONS AND TERMINATION:</strong>
              <br />
              <br />
              <ol>
                <li>
                  <strong>TAWAL Modifications:</strong> TAWAL reserves the right to modify or
                  discontinue the System or any part thereof, temporarily or permanently, with or
                  without notice.
                </li>
                <br />
                <li>
                  <strong>User Termination:</strong> Users may terminate their Accounts at any time
                  by following the Account termination procedures outlined below and/or any other
                  procedures communicated by TAWAL from time to time:
                  <br />
                  Users must:
                  <br />
                  <ol>
                    <li> Log in to their Account on the System,</li>
                    <li> Navigate to the Account Settings or Account Management section.</li>
                    <li> Select the option to deactivate or delete the Account.</li>
                    <li>
                      {' '}
                      Follow any additional prompts or confirmation steps to complete the
                      termination process.
                    </li>
                    <li>
                      {' '}
                      Contact TAWAL&#39;s customer support if any assistance is required during the
                      termination process.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  <strong>TAWAL Termination:</strong> TAWAL may terminate or suspend a User&#39;s
                  access or use to the System at any time, with or without notice, for any violation
                  of these Terms of Use or other reasons at TAWAL&#39;s sole discretion.
                </li>
                <br />
                <li>
                  <strong>Effect of Termination:</strong> Upon termination, all rights granted to
                  the Users under these Terms of Use will cease immediately. Users must cease all
                  access or use of the System and destroy any copies of all Contents obtained from
                  the System. TAWAL reserves the right to retain certain Data for a period of time
                  as required by the applicable laws and regulations or for legitimate business
                  purposes.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>SECURITY MEASURES:</strong>
              <br />
              <br />
              <ol>
                <li>
                  TAWAL implements industry-standard security measures to protect the System and
                  User&#39;s Data against unauthorized access, loss, alteration, or destruction.
                  These measures include encryption, access controls, and regular security
                  assessments.
                </li>
                <br />
                <li>
                  Users are responsible for maintaining the security of their devices and ensuring
                  that they use secure methods to access the System. Users must not bypass or
                  attempt to bypass any security measures implemented by TAWAL.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>DATA BACKUP AND RECOVERY:</strong>
              <br />
              <br />
              <ol>
                <li>
                  TAWAL performs regular backups of all Data stored on the System to ensure Data
                  integrity and availability. However, TAWAL cannot guarantee that there will be no
                  loss of Data and encourages Users to keep their own backups of any important
                  information.
                </li>
                <br />
                <li>
                  In the event of a System failure or Data loss, TAWAL will make reasonable efforts
                  to restore Data from the most recent backup. TAWAL is not liable for any loss of
                  Data or any consequences arising from such loss.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>FEEDBACK AND SUGGESTIONS:</strong>
              <br />
              <br />
              <ol>
                <li>
                  TAWAL welcomes feedback, comments, and suggestions for improvements to the System
                  (&quot;<strong>Feedback</strong>&quot;). Users can submit Feedback by contacting
                  TAWAL via TAWAL Contact Details.
                </li>
                <br />
                <li>
                  By submitting Feedback, Users grant TAWAL a non-exclusive, royalty-free,
                  worldwide, perpetual license to use, modify, and incorporate such Feedback into
                  the System without any obligation to compensate the User.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>CONTACT INFORMATION:</strong>
              <br />
              <br />
              <ol>
                <li>
                  For support, privacy concerns, Feedback, or other inquiries, Users can contact
                  TAWAL at (the “<strong>TAWAL Contact Details</strong>”):
                  <ul>
                    <dl>&nbsp; Email: contact@tawal.com.sa</dl>
                    <dl>&nbsp; Phone: 800 124 0008</dl>
                    <dl>
                      &nbsp; Address: 3210 Al-Thumama Road, Al-Sahafa District, Riyadh 13315 - 6228
                    </dl>
                  </ul>
                </li>
                <br />
                <li>TAWAL aims to respond to all inquiries within five (5) business days</li>
                <br />
                <li>
                  By using the System, Users consent to receive electronic communications from
                  TAWAL. These communications may include notices about the User’s Account and
                  information concerning or related to the System. Users agree that any notices,
                  agreements, disclosures, or other communications that TAWAL sends electronically
                  will satisfy any legal communication requirements, including that such
                  communications be in writing.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>ENTIRE AGREEMENT:</strong>
              <br />
              These Terms of Use constitute the entire agreement between the User and TAWAL
              regarding the use of the System and supersede any prior or contemporaneous agreements,
              communications, or understandings, whether written or oral.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>SEVERABILITY:</strong>
              <br />
              If any provision of these Terms of Use is held to be invalid, illegal, or
              unenforceable, such provision shall be severed, and the remaining provisions shall
              continue in full force and effect.
            </li>
            <br />
            <li>
              &nbsp;&nbsp;
              <strong>NO WAIVER:</strong>
              <br />
              TAWAL&#39;s failure to enforce any right or provision of these Terms of Use will not
              be deemed a waiver of such right or provision. Any waiver of any provision of these
              Terms of Use will be effective only if in writing and signed by TAWAL.
            </li>
            <br />
            <li>
              <strong>GOVERNING LANGUAGE:</strong>
              <br />
              These Terms of Use are drafted in the English language. If these Terms of Use are
              translated into any other language, the English language version shall govern and
              prevail in the event of any conflict or inconsistency.
            </li>
            <br />
          </ol>
        </div>

        <div dir="rtl">
          <p>
            یرجى قراءة شروط الاستخدام التالیة التي تحكم استخدام أنظمة توال بعنایة قبل الوصول إلى
            النظام أو استخدامه. من خلال الوصول إلى النظام أو استخدامه، فإنك توافق على الالتزام بهذه
            الشروط والأحكام وأي سیاسات أو إرشادات أخرى تنفذها توال. إذا كنت لا توافق على شروط
            الاستخدام هذه، ف یرجى عدم استخدام النظام. إذا كنت توافق على الالتزام بهذه الشروط، یرجى
            النقر فوق &quot;موافق&quot; أو &quot;قبول&quot;. یرجى ملاحظة أنه بالنقر على
            &quot;موافق&quot; أو &quot;قبول&quot; أو استخدام أي من الأنظمة، فإنك تؤكد قبولك لهذه
            الشروط والأحكام والتزامك بها بالكامل.
          </p>
          <br />
          <ol>
            <li>
              &nbsp;
              <strong> التعاریف:</strong>
              <br />
              <br />
              <ol>
                <li>
                  &nbsp;<strong>الحساب:</strong> یشیر إلى حساب مستخدم تم إنشاؤه بواسطة المستخدم
                  للوصول إلى النظام أو استخدام میزات أو خدمات معینة على النظام.
                </li>
                <br />
                <li>
                  &nbsp;<strong>المحتوى:</strong> یشیر إلى (أ) أي نصوص أو صور أو مقاطع فیدیو أو صوت
                  أو سجلات أو بیانات وصفیة أو أي مواد أخرى یتم نشرها أو توزیعها بواسطة توال على
                  النظام، و(ب) أي بیانات أو معلومات أو وثائق یتم تحمیلها أو تقدیمها بواسطة المستخدم
                  على النظام.
                </li>
                <br />
                <li>
                  &nbsp;<strong>البیانات:</strong> تشیر إلى أي معلومات، بما في ذلك البیانات الشخصیة
                  والمحتوى، و التي یتم جمعها أو تخزینها أو معالجتها بواسطة توال من خلال النظام.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الملاحظات:</strong> تشیر إلى المعنى المذكور في البند الفرعي رقم 19.1
                </li>
                <br />
                <li>
                  &nbsp;<strong>الملكیة الفكریة:</strong>
                  تشیر إلى جمیع حقوق التألیف والنشر والعلامات التجاریة وبراءات الاختراع والأسرار
                  التجاریة وغیرها من حقوق الملكیة الفكریة، سواء كانت مسجلة أو غیر مسجلة.
                </li>
                <br />
                <li>
                  &nbsp;<strong>البیانات الشخصیة:</strong>
                  تشیر إلى أي معلومات شخصیة تتعلق بشخص طبیعي محدد أو یمكن تحدیده، بما في ذلك معلومات
                  المستخدم الشخصیة (مثل الأسماء، معلومات الاتصال، بیانات الاستخدام، وغیرها) كما هو
                  محدد في الأنظمة السعودیة الساریة لحمایة البیانات الشخصیة.
                </li>
                <br />
                <li>
                  &nbsp;<strong>النظام: </strong> یشیر إلى أي من المواقع الإلكترونیة لتوال أو
                  منصاتها أو برامجها أو تطبیقاتها أو أنظمتها الرقمیة التي یمكن للمستخدم الوصول إلیها
                  أو استخدامها.
                </li>
                <br />
                <li>
                  &nbsp;<strong>توال:</strong> تشیر إلى
                  <strong> شركة أبراج الاتصالات – </strong>
                  شركة شخص واحد مساهمة مقفلة، وهي شركة سعودیة تأسست وفق تحت رقم السجل التجاري
                  (1010933182) ،و مقرها في برج توال، المبنى رقم ،3210 طریق الثمامة، حي الصحافة،
                  الریاض 13315 - 6228 , المملكة العربیة السعودیة، المالك والمشغل النظام.
                </li>
                <br />
                <li>
                  &nbsp;<strong>بیانات التواصل مع توال:</strong>
                  تشیر إلى المعنى المذكور في البند الفرعي رقم 20,1.
                </li>
                <br />
                <li>
                  &nbsp;<strong>شروط الاستخدام:</strong>
                  تشیر إلى هذه الشروط والأحكام والتي تنظم استعمال المستخدم للنظام والوصول إلیه، بما
                  في ذلك أي تعديلات أو إضافات أو تحدیثات تجریها توال على هذه الشروط والأحكام من وقت
                  لآخر.
                </li>
                <br />
                <li>
                  &nbsp;<strong>المستخدم أو المستخدمین:</strong>
                  یشیر إلى أي فرد أو كیان یتفاعل مع النظام أو یصل إلیه، بما في ذلك المطورین
                  والمستخدمین النهائیین والأطراف المصرحة الأخرى.
                </li>
                <br />
              </ol>
            </li>
            <br />
            <li>
              <strong>حقوق ومسؤولیات المستخدم</strong>
              <ol>
                <br />
                <li>
                  &nbsp;<strong>حقوق المستخدم</strong>
                  <br />
                  <br />
                  <ol>
                    <li>
                      &nbsp;<strong>الوصول والاستخدام:</strong>
                      يحق للمستخدمين الوصول إلى النظام واستخدامه وفقاً لشروط الاستخدام، مع المراعاة
                      الدائمة للأنظمة واللوائح السارية.
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>الخصوصية:</strong>
                      للمستخدمين الحق في الخصوصية وحماية البيانات النحو الموضح في البند الفرعي رقم
                      ‎4 (سياسة الخصوصية). كما تلتزم توال بحماية البيانات الشخصية التي يتشاركها
                      المستخدمين.
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>الدعم:</strong> يحق للمستخدمين الاتصال بفريق الدعم في توال
                      للحصول على المساعدة في الوصول إلى النظام أو استخدامه وحل أي مشكلات يواجهونها.
                      سيتم التعامل مع طلبات الدعم وفقًا للعمليات المعمول بها في توال.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  &nbsp;<strong>مسؤوليات المستخدم:</strong>
                  <ol>
                    <br />
                    <li>
                      &nbsp;<strong>الالتزام بالأنظمة:</strong>
                      يجب على المستخدمين الالتزام بجميع الأنظمة واللوائح السارية عند استخدام النظام.
                      يشمل ذلك، على سبيل المثال لا الحصر، الأنظمة المتعلقة بالملكية الفكرية وحماية
                      البيانات والخصوصية.
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>أمان الحساب:</strong>
                      يكون المستخدمين مسؤولين عن الحفاظ على سرية وثائق تفويض الحساب وعن جميع الأنشطة
                      التي تحدث في إطار الحساب. يجب على المستخدمين إبلاغ توال فورًا عن أي استخدام
                      غير مصرح به للحساب.
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>السلوك المحظور:</strong>
                      يجب على المستخدمين عدم الانخراط في أي نشاط:
                      <ol>
                        <li>
                          &nbsp;ينتهك حقوق الآخرين، بما في ذلك حقوق الملكية الفكرية وحقوق الخصوصية.
                        </li>
                        <li>.&nbsp;غير نظامي أو احتيالي أو ضار.</li>
                        <li>. &nbsp;ينطوي على نقل برامج ضارة أو فيروسات أو أي رمز ضار آخر.</li>
                        <li>. &nbsp;يتداخل مع النظام أو خدماته أو يخل بها.</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>معايير المحتوى:</strong>
                      يجب على المستخدمين التأكد من أن أي محتوى ينشر أو يقدم إلى توال عبر المستخدمين
                      وذلك من خلال النظام:
                      <ol>
                        <li>&nbsp;دقيق وفير مضلل.</li>
                        <li>&nbsp;لا ينتهك حقوق أي طرف ثالث.</li>
                        <li>&nbsp;غير مهين أو فاحش أو غير لائق.</li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>شروط تقديم طلب خدمة التغطية الداخلية (IBS):</strong>
                      <ol>
                        <li>
                          &nbsp;لتمكين توال من استخدام والانتفاع بالموقع لتنفيذ أعمال التغطية
                          الداخلية (IBS)
                        </li>
                        <li>
                          &nbsp;جميع معدات التغطية الداخلية (IBS) هي ملكية حصرية لتوال و/أو لمشغلي
                          الشبكات المعنيين، ولا يحق للمالك بأي حال من الأحوال الوصول إلى هذه المعدات
                          أو حجزها أو الحجز عليها و/أو تشغيلها.
                        </li>
                        <li>
                          &nbsp;جميع معدات التغطية الداخلية (IBS) محفوظة في الموقع، ويجب الحفاظ
                          عليها وإبقاؤها آمنة وبحالة جيدة وفق الأصول المهنية، وعدم التسبب بأي ضرر
                          لأي من هذه المعدات، وعدم إساءة استخدامها أو نقلها أو تفكيكها و/أو تعطيل
                          استخدامها أو التصرف بها بأي شكل من الأشكال دون الحصول على موافقة خطية
                          مسبقة وحضور فعلي من قبل توال وممثلها المعتمد في هذا الشأن.
                        </li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      &nbsp;<strong>الإبلاغ عن المخالفات:</strong>يتعين على المستخدمين الإبلاغ عن أي
                      انتهاكات أو سلوك غير لائق فيما يتعلق بشروط الإستخدام هذه.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>السرية:</strong>
              <ol>
                <li>
                  &nbsp;
                  <strong>المعلومات السرية:</strong>
                  <ol>
                    <li>
                      &nbsp; يقر المستخدمين بأن جميع المعلومات، بما في ذلك جميع المعلومات الخاصة
                      بالأطراف الثالثة، التي يتم تقديمها أو كشفها لهم أثناء وصولهم إلى النظام أو
                      استخدامهم له (<strong>&quot;المعلومات السرية&quot;</strong>) يجب أن تُعامل على
                      أنها سرية ولا يجوز كشفها أو مشاركتها أو إساءة استخدامها بأي شكل من الأشكال.
                    </li>
                    <br />
                    <li>
                      &nbsp;لا يجوز للمستخدمين كشف أي معلومات سرية لأطراف ثالثة دون الحصول على
                      موافقة خطية مسبقة من توال. يجب على المستخدمين التأكد من أن أي أطراف ثالثة
                      تتلقى معلومات سرية موجبة بالتزامات السرية على الأقل بنفس صرامة تلك المذكورة في
                      شروط الإستخدام هذه.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  &nbsp;<strong>الالتزامات:</strong>
                  <br />
                  يجب على المستخدمين الحفاظ على سرية أي معلومات سرية يتم الوصول إليها أو الحصول
                  عليها من خلال النظام واستخدام هذه المعلومات السرية فقط للغرض الذي تم تقديمها من
                  أجله. يجب على المستخدمين اتخاذ جميع التدابير المعقولة لحماية سرية جميع المعلومات
                  السرية.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الاستثناءات:</strong>
                  <br />
                  يفهم المستخدمين أن التزامات السرية لا تنطبق على المعلومات المتاحة للعامة أو التي
                  تصبح معروفة للعامة دون خطأ من جانب المستخدمين. كما يفهم المستخدمين أنهم غير ملزمين
                  بالحفاظ على سرية أي معلومات يمكنهم إثبات أنها كانت معروفة لديهم قبل الوصول إلى
                  النظام أو استخدامه.
                </li>
                <br />
                <li>
                  &nbsp;<strong>مسئولية المستخدم:</strong>
                  <br />
                  <ol>
                    <br />
                    <li>
                      &nbsp;يتحمل المستخدمين وحدهم المسؤولية عن أي كشف غير مصرح به أو استخدام
                      للمعلومات السرية التي يتم الحصول عليها من خلال النظام، ويجب عليهم تعويض توال
                      وإعفائها من أي خسائر أو أضرار أو التزامات ناشئة عن مثل هذا الكشف أو الاستخدام
                      غير المصرح به.
                    </li>
                    <br />
                    <li>
                      &nbsp;يجب على المستخدمين الالتزام بجميع أنظمة حماية البيانات والخصوصية المطبقة
                      عند التعامل مع المعلومات السرية.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  &nbsp;<strong>المدة:</strong>
                  <br />
                  ستستمر الالتزامات بالسرية الموضحة في هذا البند بعد انتهاء أو انقضاء وصول المستخدم
                  إلى النظام وتظل سارية إلى أجل غير مسمى.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الإجراءات الإصلاحية والتعويضية:</strong>
                  <br />
                  <ol>
                    <br />
                    <li>
                      &nbsp; تحتفظ توال بحق إنهاء وصول المستخدم إلى النظام فور اكتشاف أي انتهاك
                      للسرية. وفي مثل هذه الحالات، يحق لتوال:
                      <ol>
                        <br />
                        <li>
                          &nbsp; اتخاذ إجراءات نظامية ضد المستخدمين الذين ينتهكون السرية لاستعادة أي
                          خسائر أو أضرار تكبدتها نتيجة لمثل هذا الانتهاك، و
                        </li>
                        <br />
                        <li>
                          &nbsp;طلب أمر قضائي بوقف أي كشف أو استخدام غير مصرح به للمعلومات السرية،
                          أو اتخاذ أي تدابير احترازية نظامية أخرى لحماية هذه المعلومات.
                        </li>
                        <br />
                        <li>
                          &nbsp; يجب على المستخدمين إبلاغ توال فورًا عن أي شك أو انتهاك فعلي للسرية
                          والتعاون الكامل مع أي تحقيق.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>سياسة الخصوصية:</strong>
              <br />
              <ol>
                <br />
                <li>
                  &nbsp;<strong>جمع البيانات الشخصية:</strong>
                  <br />
                  يقر المستخدمين بأن توال يحق لها جمع ومعالجة بياناتهم الشخصية أثناء عملية التسجيل
                  وأثناء استخدامهم أو وصولهم إلى النظام.
                </li>
                <br />
                <li>
                  &nbsp;<strong>استخدام البيانات الشخصية:</strong>
                  <br />
                  تستخدم توال البيانات الشخصية المقدمة من قبل المستخدمين لتوفير وتحسين خدماتها،
                  والتواصل مع المستخدمين، والامتثال للمتطلبات النظامية.
                </li>
                <br />
                <li>
                  &nbsp;<strong>حماية البيانات الشخصية:</strong>
                  <br />
                  تنفذ توال تدابير تقنية وتنظيمية مناسبة لحماية بيانات المستخدمين الشخصية من الوصول
                  غير المصرح به أو الفقد أو التعديل أو التلف.
                </li>
                <br />
                <li>
                  &nbsp;<strong>حقوق المستخدم:</strong>
                  <br />
                  يحق للمستخدمين الوصول إلى بياناتهم الشخصية وتصحيحها وحذفها وتقييد معالجتها، كما هو
                  محدد في القوانين واللوائح المطبقة. يمكن للمستخدمين ممارسة هذه الحقوق من خلال
                  الاتصال المباشر بتوال باستخدام بيانات التواصل الخاصة بتوال.
                </li>
                <br />
                <li>
                  &nbsp;<strong>مشاركة البيانات مع الأطراف الثالثة:</strong>
                  <br />
                  قد تقوم توال بمشاركة البيانات الشخصية مع أطراف ثالثة موثوقة عند الضرورة لتحسين
                  خدماتها. جميع البيانات المشاركة مع الأطراف الثالثة تتم وفقًا للأنظمة واللوائح
                  السارية في المملكة العربية السعودية، كما يتم تطبيق اتفاقيات سرية متينة لحماية
                  المعلومات الشخصية.
                </li>
                <br />
                <li>
                  &nbsp;<strong>حفظ البيانات والتخلص منها:</strong>
                  <br />
                  ستقوم توال بحفظ البيانات الشخصية لمدة لا تتجاوز المدة اللازمة لتحقيق الغرض الذي
                  جمعت من أجله، أو كما هو مطلوب بموجب الأنظمة واللوائح المطبقة. بعد انتهاء الفترة
                  المطلوبة لحفظ البيانات، ستقوم توال بالتخلص من البيانات الشخصية بطريقة آمنة تمنع
                  الوصول غير المصرح به.
                </li>
                <br />
                <li>
                  &nbsp;<strong>حظر الاستخدام غير المصرح به للمحتوى:</strong>
                  <br />
                  <ol>
                    <li>
                      &nbsp; لا يجوز للمستخدمين:
                      <ol>
                        <li>
                          &nbsp; نسخ أو لصق أي محتوى من النظام لأي غرض لا يصرح به صراحة في شروط
                          الاستخدام هذه.
                        </li>
                        <li>
                          &nbsp;إعادة توزيع أي من محتوى النظام على أطراف ثالثة أو أي منصات خارجية
                          دون الحصول على موافقة خطية مسبقة من توال،
                        </li>
                        <li>
                          &nbsp;إعادة استخدام أي محتوى من النظام لأغراض تجارية أو غير تجارية خارج
                          نطاق شروط الاستخدام هذه دون الحصول على إذن خطي صريح من توال.
                        </li>
                      </ol>
                    </li>
                    <br />
                    <li>
                      &nbsp; يجب أن يكون استخدام المحتوى من النظام ممتثلًا لشروط الاستخدام هذه وكافة
                      الأنظمة واللوائح المعمول بها. وأي استخدام غير مصرح به، بما في ذلك النسخ،
                      واللصق، وإعادة التوزيع، أو إعادة استخدام المحتوى، ممنوع صراحةً وقد يؤدي إلى
                      إنهاء الاستخدام واتخاذ إجراءات نظامية.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  &nbsp;<strong>إشعار انتهاك البيانات:</strong>
                  <ol>
                    <br />
                    <li>
                      &nbsp; في حالة حدوث انتهاك للبيانات يؤثر على البيانات الشخصية للمستخدمين،
                      ستقوم توال بإخطار المستخدمين المتأثرين والسلطات ذات الصلة وفقًا للأنظمة
                      واللوائح المعمول بها.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp; <strong>خصوصية الأطفال</strong> <br />
              لا تقوم توال بجمع بيانات شخصية من الأطفال دون سن 13 عامًا بشكل متعمد دون الحصول على
              موافقة كتابية قابلة للتحقق من الوالدين. إذا أصبحت توال على علم بأن طفلاً دون سن 13
              عامًا قد قدم بيانات شخصية دون الحصول على هذه الموافقة، فستقوم توال بحذف هذه المعلومات
              من النظام.
            </li>
            <br />
            <li>
              &nbsp;<strong>الملكية الفكرية</strong>
              <ol>
                <li>
                  &nbsp;<strong>ملكية المحتوى:</strong>
                  <br />
                  جميع المحتويات الموجودة على النظام هي ملكية توال أو موردي المحتوى الخاص بها، وهي
                  محمية بموجب قوانين حقوق النشر والعلامات التجارية والعلامات التجارية والأسرار
                  التجارية وغيرها من قوانين الملكية الفكرية أو الملكية.
                </li>
                <br />
                <li>
                  &nbsp;<strong>العلامات التجارية:</strong>
                  <br />
                  جميع العلامات التجارية وعلامات الخدمة والشعارات والأسماء التجارية المعروضة على
                  النظام هي ملكية توال أو أصحابها المعنيين. لا يجوز للمستخدمين استخدام أي علامة
                  تجارية أو علامة خدمة أو شعار أو اسم تجاري لتوال أو أي طرف ثالث دون الحصول على إذن
                  خطي مسبق من المالك.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الترخيص والوصول:</strong>
                  <br />
                  تمنح توال للمستخدمين ترخيصًا محدودًا وغير حصري وغير قابل للتحويل وقابل للإلغاء
                  للوصول إلى النظام واستخدامه للأغراض الشخصية غير التجارية فقط. لا يشمل هذا الترخيص
                  أي إعادة بيع أو استخدام تجاري للنظام أو محتواه؛ أو أي جمع واستخدام لأي قوائم
                  منتجات أو مواصفات أسعار؛ أو أي استخدام مشتق للنظام أو محتواه؛ أو أي تنزيل أو نسخ
                  لمعلومات الحساب لصالح تاجر آخر؛ أو أي استخدام تنقيب البيانات أو الروبوتات أو أدوات
                  جمع البيانات واستخراجها المماثلة.
                </li>
                <br />
                <li>
                  &nbsp;<strong>القيود:</strong> <br />
                  لا يجوز للمستخدمين تأطير أو استخدام تقنيات التأطير لإحاطة أي علامة تجارية أو شعار
                  أو أي معلومات أخرى مملوكة (بما في ذلك الصور والنصوص وتخطيط الصفحة أو النموذج)
                  لتوال دون الحصول على موافقة خطية صريحة. تشمل تقنيات التأطير، على سبيل المثال لا
                  الحصر، عرض محتوى توال ضمن إطار أو حدود على موقع ويب آخر، مما يجعله يبدو كما لو أن
                  المحتوى ينتمي إلى موقع التأطير. لا يجوز للمستخدمين استخدام أي علامات ميتا أو أي
                  &quot;نص مخفي&quot; آخر يستخدم اسم توال أو علاماتها التجارية دون الحصول على موافقة
                  خطية مسبقة صريحة من توال.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الإبلاغ عن الانتهاكات:</strong>
                  <br />
                  إذا اعتقد المستخدمين أن أي محتوى على النظام ينتهك حقوق الملكية الفكرية الخاصة بهم،
                  فإنهم مدعوون للإبلاغ عن ذلك لتوال. ستقوم توال بالتحقيق واتخاذ الإجراءات المناسبة
                  حسب الحاجة.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>بيانات مُنشأة بواسطة المستخدمين:</strong>
              <br />
              <ol>
                <br />
                <li>
                  &nbsp;<strong>الاستخدام المقبول:</strong>
                  يتحمل المستخدمين مسؤولية التأكد من أن أي بيانات يقومون بنشرها أو تقديمها إلى
                  النظام مناسبة وقانونية ولا تنتهك أي حقوق للآخرين. ويشمل ذلك تجنب المحتوى المسيء أو
                  الهجومي أو المضلل.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الرقابة والإزالة:</strong>
                  تحتفظ توال بالحق في مراقبة ومراجعة وإزالة أي بيانات مُنشأة بواسطة المستخدمين
                  وتنتهك شروط الاستخدام هذه أو تكون غير مناسبة بأي شكل آخر.
                </li>
                <br />
                <li>
                  &nbsp;<strong>ملكية البيانات:</strong>
                  من خلال تقديم البيانات إلى النظام، يمنح المستخدمين توال ترخيصًا عالميًا وغير حصري
                  لاستخدام هذه البيانات ومعالجتها فيما يتعلق بالنظام.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>روابط وخدمات الغير:</strong>
              <br />
              <ol>
                <br />
                <li>
                  &nbsp;<strong>إخلاء المسؤولية:</strong>
                  قد يحتوي النظام على روابط لمواقع أو خدمات تابعة للغير لا تمتلكها أو تتحكم بها
                  توال. ليس لدى توال أي سيطرة على محتوى أو سياسات الخصوصية أو ممارسات أي من مواقع أو
                  خدمات الغير، ولا تتحمل أي مسؤولية عنها. يتعين على المستخدمين، ولديهم المسؤولية
                  الكاملة لمراجعة محتوى سياسات الغير وسياسات الخصوصية أو الممارسات قبل استخدام
                  خدماتها.
                </li>
                <br />
                <li>
                  &nbsp;<strong>مسؤولية المستخدم:</strong>
                  يقر المستخدمين ويوافقون على أن توال لن تكون مسؤولة أو مطالبة بالتعويض، بشكل مباشر
                  أو غير مباشر، عن أي ضرر أو خسارة ناتجة أو يُزعم أنها ناتجة عن أو مرتبطة باستخدام
                  أو الاعتماد على أي من هذا المحتوى أو البضائع أو الخدمات المتاحة على أو من خلال أي
                  من هذه المواقع أو الخدمات.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>ملفات تعريف الارتباط والتتبع:</strong>
              <br />
              تستخدم توال ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتتبع النشاط على النظام وحفظ
              بعض المعلومات. يمكن للمستخدمين توجيه متصفحاتهم لرفض جميع ملفات تعريف الارتباط أو
              للإشارة عند إرسال ملف تعريف ارتباط. ومع ذلك، إذا لم يقبل المستخدمين ملفات تعريف
              الارتباط، فقد لا يتمكنون من استخدام بعض أجزاء النظام.
            </li>
            <br />
            <li>
              &nbsp;<strong>إخلاء المسؤولية والحدود القصوى للمسؤولية:</strong>
              <br />
              <ol>
                <br />
                <li>
                  &nbsp;<strong>عدم وجود ضمانات:</strong>
                  <br />
                  تقدم توال النظام وخدماته &quot;كما هي&quot; و&quot;كما هي متاحة&quot;، دون أي
                  ضمانات من أي نوع، سواء صريحة أو ضمنية. لا تضمن توال أن يكون النظام خاليًا من
                  الأخطاء أو غير متقطع أو آمنًا.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الحد من المسؤولية:</strong>
                  <br />
                  إلى أقصى حد تسمح به الأنظمة السارية، لن تكون توال مسؤولة عن أي أضرار غير مباشرة أو
                  عرضية أو خاصة أو تبعية أو عقابية، أو أي خسارة في الأرباح أو الإيرادات، سواء تكبدت
                  بشكل مباشر أو غير مباشر، أو أي خسارة في البيانات أو الاستخدام أو السمعة التجارية
                  أو الخسائر غير المادية الأخرى الناجمة عن (1) استخدام النظام أو عدم القدرة على
                  الوصول إليه أو استخدامه؛ أو (2) أي سلوك أو محتوى لأي طرف ثالث على النظام؛ أو (3)
                  أي محتوى تم الحصول عليه من النظام؛ أو (4) الوصول غير المصرح به أو الاستخدام أو
                  التغيير غير المصرح به لنقلات المستخدمين أو محتواهم.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>التعويض:</strong> <br />
              يتعين على المستخدمين تعويض توال وحمايتها من أي مطالبات أو أضرار أو التزامات أو تكاليف
              أو مصاريف ناشئة عن استخدامهم للنظام أو أي انتهاك لشروط الاستخدام هذه.
            </li>
            <br />
            <li>
              &nbsp;<strong>القوة القاهرة:</strong> <br />
              لن تكون توال مسؤولة عن أي إخفاق في الأداء أو تأخير في تنفيذ التزاماتها بموجب شروط
              الاستخدام هذه إذا كان هذا الإخفاق أو التأخير ناتجًا عن أسباب خارجة عن سيطرتها
              المعقولة، بما في ذلك على سبيل المثال لا الحصر، الكوارث الطبيعية، الحروب، الإرهاب،
              الإضرابات، الحصارات، الأوبئة، أوامر الحكومة، أو أحداث أخرى من القوة القاهرة.
            </li>
            <br />
            <li>
              &nbsp;<strong>تغييرات الشروط:</strong> <br />
              تحفظ توال الحق في تعديل شروط الاستخدام هذه في أي وقت. سيتم إخطار المستخدمين بأي
              تغييرات جوهرية، ويعتبر استمرار استخدام المستخدمين للنظام بعد هذه التغييرات بمثابة
              قبولهم لشروط الاستخدام المعدلة أو المحدثة.
            </li>
            <br />
            <li>
              &nbsp;<strong>حل النزاعات:</strong> <br />
              في حالة نشوء أي نزاع ناشئ عن أو متعلق بشروط الاستخدام هذه أو استخدام النظام، يتفق
              الطرفان على محاولة التفاوض بحسن نية لحل النزاع أولاً. إذا لم يتم حل النزاع من خلال
              التفاوض، يتفق الطرفان على محاولة حل النزاع من خلال الوساطة قبل اللجوء إلى التقاضي.
            </li>
            <br />
            <li>
              &nbsp;<strong>القانون الحاكم والمحاكم المختصة:</strong>
              <br />
              <ol>
                <br />
                <li>
                  &nbsp;<strong>القانون الحاكم:</strong>
                  تخضع شروط الاستخدام هذه وتفسر وفقًا لقوانين المملكة العربية السعودية.
                </li>
                <br />
                <li>
                  &nbsp;<strong>الاختصاص القضائي:</strong>
                  تخضع أي نزاعات لم يتم حلها ودياً من خلال الوساطة، الناشئة عن أو المتعلقة بشروط
                  الاستخدام هذه أو استخدام النظام للاختصاص القضائي الحصري للمحاكم المختصة في الرياض،
                  المملكة العربية السعودية.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>التعديلات والإنهاء:</strong>
              <ol>
                <br />
                <li>
                  &nbsp;<strong>تعديلات توال:</strong>
                  تحتفظ توال بالحق في تعديل أو وقف النظام أو أي جزء منه، مؤقتًا أو دائمًا، مع أو
                  بدون إشعار.
                </li>
                <br />
                <li>
                  &nbsp;<strong>إنهاء عضوية المستخدمين:</strong>
                  يحق للمستخدمين إنهاء حساباتهم في أي وقت باتباع إجراءات إنهاء الحساب الموضحة أدناه
                  أو أي إجراءات أخرى يتم التواصل بها من قبل توال من وقت لآخر:
                  <br />
                  <br />
                  يجب على المستخدمين:
                  <ol>
                    <li> تسجيل الدخول إلى حساباتهم على النظام.</li>
                    <li> الانتقال إلى قسم إعدادات الحساب أو إدارة الحساب.</li>
                    <li> تحديد خيار إلغاء تنشيط الحساب أو حذفه.</li>
                    <li> اتباع أي مطالبات أو خطوات تأكيد إضافية لإكمال عملية الإنهاء.</li>
                    <li>
                      &nbsp;اتصل بدعم العملاء في شركة توال في الاحتياج إلى أي مساعدة أثناء عملية
                      الإنهاء.
                    </li>
                  </ol>
                </li>
                <br />
                <li>
                  &nbsp;<strong>إنهاء عضوية المستخدمين من قبل توال:</strong>
                  قد تقوم توال بإنهاء أو تعليق وصول المستخدم أو استخدامه للنظام في أي وقت، مع أو
                  بدون إشعار، لأي انتهاك لشروط الاستخدام هذه أو لأسباب أخرى حسب تقدير توال.
                </li>
                <br />
                <li>
                  &nbsp;<strong>آثار إنهاء عضوية المستخدمين:</strong>
                  عند الإنهاء، ستتوقف جميع الحقوق الممنوحة للمستخدمين بموجب شروط الاستخدام هذه. يجب
                  على المستخدمين وقف الوصول إلى النظام أو استخدامه وإتلاف أي نسخ من جميع المحتويات
                  التي تم الحصول عليها من النظام. تحتفظ توال بالحق في إبقاء بيانات معينة لفترة من
                  الوقت وفقًا للأنظمة واللوائح المعمول بها أو لأغراض تجارية مشروعة.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>تدابير أمنية:</strong> <br />
              <ol>
                <br />
                <li>
                  &nbsp; تطبق توال تدابير أمنية وفقًا للمعايير الصناعية لحماية النظام وبيانات
                  المستخدمين من الوصول غير المصرح به أو الفقد أو التغيير أو التدمير.
                  <br />
                  <br />
                  تشمل هذه التدابير التشفير والضوابط الأمنية وتقييمات الأمن المنتظمة.
                </li>
                <br />
                <li>
                  &nbsp; يتحمل المستخدمين مسؤولية الحفاظ على أمان أجهزتهم والتأكد من استخدامهم طرقًا
                  آمنة للوصول إلى النظام. يجب على المستخدمين عدم تجاوز أو محاولة تجاوز أي تدابير
                  أمنية تنفذها توال.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>نسخ البيانات واستعادتها:</strong>
              <ol>
                <br />
                <li>
                  &nbsp; تقوم توال بإجراء نسخ احتياطية منتظمة لجميع البيانات المخزنة على النظام
                  لضمان سلامة البيانات وتوافرها. ومع ذلك، لا يمكن لتوال ضمان عدم فقدان البيانات
                  وتشجع المستخدمين على الاحتفاظ بنسخ احتياطية خاصة بهم لأي معلومات مهمة.
                </li>
                <br />
                <li>
                  &nbsp; في حالة حدوث عطل في النظام أو فقدان البيانات، ستبذل توال جهودًا معقولة
                  لاستعادة البيانات من أحدث نسخة احتياطية. لا تتحمل توال المسؤولية عن أي فقدان
                  للبيانات أو أي عواقب ناتجة عن هذا الفقد.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>الملاحظات والاقتراحات:</strong>
              <ol>
                <br />
                <li>
                  &nbsp;ترحب توال بالملاحظات والتعليقات والاقتراحات لتحسين النظام
                  (&quot;التعليقات&quot;). يمكن للمستخدمين تقديم التعليقات عن طريق الاتصال بتوال عبر
                  تفاصيل الاتصال الخاصة بتوال.
                </li>
                <br />
                <li>
                  &nbsp; من خلال تقديم التعليقات، يمنح المستخدمين توال ترخيصًا غير حصري عالمي خالي
                  من حقوق الملكية ودائم لاستخدام هذه التعليقات وتعديلها وتضمينها في النظام دون أي
                  التزام بتعويض المستخدم.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>معلومات الاتصال:</strong>
              <ol>
                <br />
                <li>
                  &nbsp; للمساعدة أو استفسارات الخصوصية أو الملاحظات أو أي استفسارات أخرى، يمكن
                  للمستخدمين الاتصال بتوال على العنوان التالي (عنوان اتصال توال):
                  <ul>
                    <br />
                    <dl>&nbsp; البريد الإلكتروني: contact@tawal.com.sa</dl>
                    <dl>&nbsp; الهاتف: 800 124 0008</dl>
                    <dl>&nbsp; العنوان: طريق الثمامة 3210، حي الصحافة، الرياض 13315 - 6228</dl>
                  </ul>
                </li>
                <br />
                <li>&nbsp;تسعى توال للرد على جميع الاستفسارات خلال خمسة (5) أيام عمل.</li>
                <br />
                <li>
                  &nbsp; باستخدام النظام، يوافق المستخدمين على تلقي الاتصالات الإلكترونية من توال.
                  قد تشمل هذه الاتصالات إشعارات حول حساب المستخدم ومعلومات تتعلق بالنظام أو ذات صلة
                  به. يوافق المستخدمين على أن أي إشعارات أو اتفاقيات أو إفشاءات أو أي اتصالات أخرى
                  ترسلها توال إلكترونيًا ستفي بأي متطلبات نظامية للاتصالات، بما في ذلك أن تكون هذه
                  الاتصالات مكتوبة.
                </li>
              </ol>
            </li>
            <br />
            <li>
              &nbsp;<strong>الاتفاقية الكاملة:</strong>
              <br />
              تشكل شروط الاستخدام هذه الاتفاقية الكاملة بين المستخدم وتوال فيما يتعلق باستخدام
              النظام وتحل محل أي اتفاقات أو اتصالات أو تفاهمات سابقة أو معاصرة، سواء كانت مكتوبة أو
              شفوية.
            </li>
            <br />
            <li>
              &nbsp;<strong>قابليّة الفصل:</strong> <br />
              إذا ثبت أن أي حكم من أحكام شروط الاستخدام هذه غير صالح أو غير نظامي أو غير قابل
              للتنفيذ، فسيتم فصل هذا الحكم، وستظل الأحكام المتبقية نافذة ومطبقة بالكامل.
            </li>
            <br />
            <li>
              &nbsp;<strong>عدم التنازل:</strong> <br />
              عدم قيام توال بتنفيذ أي حق أو حكم من شروط الاستخدام هذه لن يعتبر تنازلاً عن هذا الحق
              أو الحكم. لن يكون أي تنازل عن أي حكم من شروط الاستخدام هذه نافذاً إلا إذا كان مكتوبًا
              وموقعًا من قبل توال.
            </li>
            <br />
            <li>
              &nbsp;<strong>اللغة الحاكمة:</strong> <br />
              صيغة شروط الاستخدام هذه باللغة الإنجليزية. إذا تم ترجمة شروط الاستخدام هذه إلى أي لغة
              أخرى، فإن الإصدار باللغة الإنجليزية يكون حاكماً وسائداً في حالة وجود أي تعارض أو
              تناقض.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
